'use client';

import dynamic from 'next/dynamic';
import Container from '@/components/common/container';

// === dynamic imports so they only SSR‑skip in the browser
const ChatBox = dynamic(
  () => import('@/components/pages/dana/chat-box/chat-box'),
  { ssr: false }
);
/**
 * Catch‑all page so both:
 *   • GET /dana/chat       → params.chatId = undefined
 *   • GET /dana/chat/123   → params.chatId = ['123']
 *
 * land here and ChatBox (which itself mounts <Chat />)
 * will create or reuse the chat as needed.
 */
export default function DanaChatPage() {
  return (
    <Container
      padding="24px"
      background="var(--color-grayBackground)"
      width="100%"
    >
      <ChatBox />
    </Container>
  );
}
